export default __webpack_public_path__ + "static/media/TBT0259_Modern_Slavery&Human_Trafficking.46b9b646.pdf";